import axios from "axios";

const clientAxios = axios.create({
    //baseURL: `${import.meta.env.VITE_BCKNDR347COMPANT_URL}/api`
    baseURL: 'https://bgpe2d50kd.execute-api.us-east-1.amazonaws.com/dev/api'
    //baseURL: 'https://api-aceromex.r347company.com/api'
    
});

export default clientAxios ;